export const PARTNER_CRITERIA = {
    cmcr: {
        provinces: new Set(['AB', 'BC', 'ON', 'MB', 'NB', 'NL', 'NS', 'SK']),
        incomeTypes: new Set(['full_time', 'part_time', 'social_security', 'retired']),
        creditSituations: new Set(['good', 'fair', 'unknown']),
        maxRequestedAmount: 10000,
    },
    skcp: {
        provinces: new Set(['AB', 'BC', 'MB', 'NB', 'NL', 'ON', 'PE', 'SK', 'NT', 'NU', 'YT']),
        incomeTypes: new Set(['full_time', 'retired']),
        creditSituations: new Set(['good', 'fair', 'unknown']),
    },
    gl: {
        provinces: new Set(['AB', 'BC', 'NB', 'PE', 'ON', 'NL']),
        incomeTypes: new Set(['full_time', 'part_time', 'gig_worker', 'self_employed']),
        minTotalIncome: 2000,
        maxRequestedAmount: 7500,
    },
    lnie: {
        provinces: new Set(['AB', 'BC', 'MB', 'NB', 'NL', 'NS', 'ON', 'PE', 'SK', 'NT', 'NU', 'YT']),
        incomeTypes: new Set(['full_time', 'part_time', 'temp_contract', 'gig_worker', 'self_employed']),
        maxRequestedAmount: 3500,
    },
};
